import { useState, useCallback, useEffect } from 'react'
import { useDebounce } from '../../hooks/useDebounce'

interface SearchInputProps {
  onSearch: (value: string) => void
  placeholder?: string
  disabled?: boolean
  id?: string
  labelText?: string
  defaultValue?: string
}

export function SearchInput({
  onSearch,
  placeholder = 'Search...',
  disabled = false,
  id = 'input',
  defaultValue = '',
}: SearchInputProps) {
  const [inputValue, setInputValue] = useState(defaultValue)
  const debouncedValue = useDebounce(inputValue, 500)

  // Call onSearch when debouncedValue changes
  useEffect(() => {
    onSearch(debouncedValue)
  }, [debouncedValue, onSearch])

  // Handle input changes
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }, [])

  return (
    <div>
      <input
        type="text"
        id={id}
        value={inputValue}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        className="block w-full pl-3 pr-3 h-10 text-slate-50 border border-base-input bg-base-secondary rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      />
    </div>
  )
}
